/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_MembersInputs */

const cs_calendar_members = /** @type {(inputs: Calendar_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé`)
};

const en_calendar_members = /** @type {(inputs: Calendar_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Calendar_MembersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_members = /** @type {((inputs?: Calendar_MembersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_MembersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_members(inputs)
	return cs_calendar_members(inputs)
});